require('core-js');require('regenerator-runtime/runtime');require('./project/header.js');
require('./feature/image-spot.js');
require('./project/getConfiguration');
import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;